<template>
  <div class="tabbar-home">
    <div class="topFloor-page">
      <span @mouseenter="enter(item.article_id)" @mouseleave="leave" v-for="(item, index) in menuList" :key="index">
        <a target="_blank" class="list" v-if="item.article_id == 0" :href="item.url">{{item.article_name}}</a>
        <span v-else class="list" :class="{'active':item.article_id == tabIndex}" @click="tabMenu(item.article_id,item.url)">{{item.article_name}}</span>
      </span>
    </div>
    <div class="typeTwo">
      <span v-for="(item, index) in type" @click="tabClick(item.article_id,item.article_name)" :key="index">{{item.article_name}}</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
export default {
  props:{
    tabIndexs:Boolean
  },
  data(){
    return{
      menuList:[{article_id:0,article_name:'首页',islast:0,url:'http://cnaite.cn/'},{article_id:1,article_name:'商学院首页',islast:0,url:'/sxy'}],
      type:[],
      pid:0,
      tabIndex:1
    }
  },
  created(){
    this.getMenu();
  },
  methods:{
    tabMenu(id,url){
      this.tabIndex = id;
      this.$store.dispatch('SET_SEARCH','');
      if(this.$router.history.current.path == url){
        return false
      }
      this.$router.push({path:url})
    },
    getMenu(){
      let that = this;
      that.menuList = [{article_id:0,article_name:'首页',islast:0,url:'http://cnaite.cn/'},{article_id:1,article_name:'商学院首页',islast:0,url:'/sxy'}];
      let url = encodeURI("/ajax/App_ArchiveClass.ashx?nums=10&class_id=61&action=article_count");
       axios.get(url).then((res) => {
         res.data.forEach((element,i) => {
            element.url = `/sxy/commerce/${element.article_id}`
            that.menuList.push(element);
         });
      })
    },
    enter(id){
      if(id == 1 || id == 0){
        this.type = [];
        return false
      }
      this.pid = id;
      this.getCommentType(id);
    },
    leave(){
      // this.getCommentType(id);
    },
    getCommentType(id){
      this.type = [];
      let url = encodeURI(`/ajax/App_ArchiveClass.ashx?class_id=${id}&nums=10&action=article_count`)
      axios.post(url).then(res=>{
        this.type = res.data;
      })
    },
    tabClick(id,name){
      this.$router.push({path:`/sxy/commerce/${this.pid}`,query:{tid:id,name:name}})
    },
  },
  watch:{
    tabIndexs(){
      this.tabIndex = 1;
    }
  }
}
</script>
<style scoped lang="scss">
.tabbar-home {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  // background: #187adc;
  background-color: #2c96ea;
  margin-bottom: 40px;
  .typeTwo{
      width: 1200px;
      height: auto;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      &>span{
        margin-right: 20px;
        font-size: 14px;
        cursor: pointer;
      }
  }
  .topFloor-page {
    width: 1200px;
    height: auto;
    margin: auto;
    
    .list {
      text-decoration: none;
      width: 80px;
      display: inline-block;
      text-align: center;
      color: #fff;
      margin-right: 10px;
      padding: 0 6px;
      cursor: pointer;
    }
    
    .active {
      background: #3ca3f5;
      color: #fff;
    }
  }
  
}
.list:hover{
  background-color: #1684dc;
}

</style>